<template>
  <div class="home">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header :title="title" />
    <div class="con">
      <dl>
        <dt>
          <img :src="appUser.avtarUrl || defaultUserIcon" alt="" />
        </dt>
        <dd>
          <span v-if="appUser.userId">{{ appUser.nickName }}</span>
          <span v-else @click="toLogin">请登录</span>
        </dd>
      </dl>
    </div>

    <!-- 链接 -->
    <mt-cell title="激活码" is-link @click="toView('#activation')">
      <span style="color: green"></span>
    </mt-cell>
  </div>
</template>

<script>
import Body from '@/mixins/body'
import { appUser } from '@/utils'
import { toLoginView } from '@/utils/init/env-init'
import { defaultUserIcon } from '@/pages/config'
// 获取绝对路径

function getAppUser() {
  const { userId, avtarUrl, nickname } = appUser
  return { userId, avtarUrl, nickname }
}

export default {
  name: 'home',
  mixins: [Body],
  data() {
    return {
      title: '个人中心',
      defaultUserIcon,
      appUser: getAppUser()
    }
  },
  activated() {
    this.toView(appUser.toView)
  },
  computed: {
    canUse() {
      let bool = false
      if (this.a && this.b) bool = true
      return bool
    }
  },
  mounted() {
    console.log(this.canUse)
  },
  methods: {
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      this.appUser = getAppUser()
    },
    toView(hash) {
      if (hash) {
        console.log('[Init] activated(toView)', appUser.toView)
        if (hash.indexOf('#') >= 0) {
          hash = hash.replace('#', '')
        }
        if (hash === '/home') {
          console.log('[Init] already home page')
          console.log(location.href)
        }
        // 跳转到业务页面
        this.$router.replace({ path: hash })
      } else {
        const h = localStorage.getItem('toViewHash')
        console.log('toViewHash', h)
        localStorage.removeItem('toViewHash')
        if (h) {
          console.log(h)
          this.$router.replace({ path: h })
        }
      }
    },
    toLogin() {
      toLoginView({ button: true, action: 'toLogin' })
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  // 用户头像
  .con {
    padding: 0 0.48rem 0.48rem;
    background-color: #ffffff;
    border-radius: 0 0 0.96rem 0.96rem;
    > dl {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0.48rem 0 0.48rem;
      dt {
        width: 0.8rem;
        height: 0.8rem;
        img {
          width: 0.8rem;
          height: 0.8rem;
          border-radius: 50%;
        }
      }
      dd {
        font-size: 0.32rem;
        font-weight: 500;
        margin-top: 0.16rem;
      }
    }
  }
}
</style>
